const Layout = () => System.import('../../Shared/Layout/App/View/Layout.vue')
const Carrinho = () => System.import('../App/View/Carrinho.vue')

export const CarrinhoRoutes = [
  {
    path: '/',
    component: Layout,
    children: [
      {path: 'carrinho', component: Carrinho, name: 'carrinho', meta: {auth: true}},
    ]
  }
]



// WEBPACK FOOTER //
// ./src/components/Carrinho/Rotas/Routes.js